// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { EmergenciesnotmanagedService } from './emergenciesnotmanaged.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Emergenciesnotmanaged } from './emergenciesnotmanaged.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatInput } from '@angular/material/input';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import Speech from 'speak-tts'
@Component({
  selector: 'app-emergenciesnotmanaged',
  templateUrl: './emergenciesnotmanaged.component.html',
  styleUrls: ['style.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ]
})
export class EmergenciesnotmanagedComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('start', { read: MatInput, static: false }) start: MatInput;
  @ViewChild('end', { read: MatInput, static: false }) end: MatInput;

  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Emergenciesnotmanaged>;
  pageEvent: PageEvent;
  pageSize = 50
  itemCount = 1000

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  speech
  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['timestamp', 'message', 'description', 'number', 'reset'];
  filterSelectObj = [];
  filterValues = {};
  filter;
  constructor(private authenticationService: AuthenticationService, private emergenciesnotmanagedService: EmergenciesnotmanagedService,
    private changeDetectorRefs: ChangeDetectorRef, private storageService: ApiService, private utilsService: UtilsService) {
    this.filterSelectObj = [
      {
        name: 'Data',
        columnProp: 'timestamp',
        options: []
      },
      {
        name: 'Messaggio',
        columnProp: 'message',
        options: []
      },
      {
        name: 'Descrizione',
        columnProp: 'description',
        options: []
      }, {
        name: 'Numero',
        columnProp: 'number',
        options: []
      },
    ]
    this.filter = { message: "", description: "", number: "", start: "", end: "" }
  }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  updateEnd(end) {
    this.filter["end"] = (new Date(end._selected._d)).getTime()
    this.getData(0, this.pageSize, this.filter)
  }
  updateStart(start) {
    this.filter["start"] = (new Date(start._selected._d)).getTime()
    this.getData(0, this.pageSize, this.filter)
  }
  public getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize, this.filter)
  }

  filterChange(filter, event) {
    this.filter[filter.columnProp] = filter.modelValue
    this.getData(0, this.pageSize, this.filter)
  }
  resetFilters() {
    this.filter = { message: "", description: "", number: "", start: "", end: "" }
    this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.dataSource.filter = "";
    this.start.value = '';
    this.end.value = '';
    this.getData(0, this.pageSize, [])
  }

  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);

      var found = 0
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          if (data[col] === searchTerms[col]) {
            found++
          }

        } else {
          delete searchTerms[col];
        }
      }
      return found == Object.keys(searchTerms).length
    }
    return filterFunction
  }
  async getData(pageIndex, pageSize, filter) {

    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    this.storageService.getEmergenciesnotmanagedcountt().subscribe(v => {
      this.itemCount = parseInt(v, 10);
    })

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile
    this.storageService.getEmergenciesnotmanaged(pageIndex, pageSize, filter).subscribe(res => {
      this.emergenciesnotmanagedService.setEmergenciesnotmanaged(res.data);
      this.dataSource = new MatTableDataSource(res.data);
  });
  
    this.subscription = this.emergenciesnotmanagedService.emergenciesnotmanagedChanged.subscribe(
      (emergenciesnotmanageds: Emergenciesnotmanaged[]) => {
        this.dataSource = new MatTableDataSource(emergenciesnotmanageds);
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento
        this.dataSource.filterPredicate = this.createFilter();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento
      }
    );
  }
  tts(message) {
    this.speech.speak({
      text: message.code != 'clear_sms' ? `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme ${message.message}` : `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme con testo libero ${message.message}`,
    })
  }

  // la prima cosa da fare entrando nella pagina è richiamare il metodo di popolamento tabella
  ngOnInit() {
    this.storageService.getEmergenciesnotmanagedColumn().subscribe(v => {
      this.filterSelectObj.filter((o) => {
        if (o.columnProp != 'timestamp') o.options = v[o.columnProp].sort();
      });
    })

    this.speech = new Speech()
    this.speech
      .init({
        volume: 1,
        lang: "it-IT",
        rate: 0.7,
        pitch: 1,
        //'splitSentences': false,
        listeners: {
          onvoiceschanged: (voices) => {
          }
        }
      })
      .then((data) => {
      })
      .catch((e) => {
      });
    this.storageService.getEmergenciesnotmanagedcount()
    
    this.getData(0, this.pageSize, [])
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  downloadFile(data, filename = 'data') {
    // let csvData = this.ConvertToCSV(data, this.displayedColumns);
    let csvData = data
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));

  }
  download() {
    this.utilsService.showLoader()
    this.storageService.getEmergenciesnotmanagedtot().subscribe(v => {
      this.downloadFile(v, 'stato_emergenze');
      this.utilsService.hideLoader()
    })
  }
}
